
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CPromoCodeDetail',
  props: {
    promoCode: {
      type: String,
    },
  },
})
